const Layout = () => import('../views/common/layout')

const import_ = file => () => import('../views' + file)

const staticRoute = [{
    path: '/',
    redirect: '/dashboard',
    component: Layout,
    children: [
      // api debug router
      {
        path: '/debug',
        name: 'debug',
        component: import_('/common/debug'),
        meta: { title: '接口调试', icon: 'settings' }
      },
      // api debug router
      {
        path: '/setting/changePwd',
        name: 'setting.changePwd',
        component: import_('/setting/profile/passwd'),
        meta: { title: '修改密码', icon: '' }
      },
      {
        path: 'dashboard',
        name: 'dashboard',
        component: import_('/dashboard'),
      },
      {
        path: 'profile',
        name: 'setting.profile',
        meta: { title: '我的企业' },
        component: import_('/setting/profile')
      },
      {
        path: '/dashboard/map',
        name: 'dashboard.map',
        meta: { title: '信息总览', mapMode: true },
        component: import_('/dashboard/map')
      },
      {
        path: '/dashboard/map/car',
        name: 'dashboard.map.car',
        meta: { title: '车辆地图', mapMode: true , type:'car' },
        component: import_('/dashboard/map')
      },
      {
        path: '/dashboard/map/company',
        name: 'dashboard.map.company',
        meta: { title: '企业地图', mapMode: true, type:'company' },
        component: import_('/dashboard/map')
      },
      {
        path: '/dashboard/screen',
        name: 'dashboard.screen',
        meta: { title: '信息总览', mapMode: true },
        component: import_('/dashboard/screen')
      },
    ]
  },
  {
    path: '/map/car',
    name: 'map.car',
    meta: { title: '信息总览'},
    component: import_('/map/car')
  },
  {
    path: '/monitor',
    name: 'monitor',
    meta: { title: '控制面板' },
    component: import_('/dashboard/monitor'),
  },
  {
    path: '/screen',
    meta: { title: '大屏展示' },
    name: 'screen',
    component: import_('/dashboard/screen')
  },
  // error router
  {
    path: '/error',
    name: 'error',
    component: import_('/common/error'),
    children: [{
        name: 'error.401',
        path: '401',
        component: import_('/common/error/401'),
      },
      {
        name: 'error.403',
        path: '403',
        component: import_('/common/error/403')
      },
      {
        name: 'error.404',
        path: '404',
        component: import_('/common/error/404')
      },
      {
        name: 'error.500',
        path: '500',
        component: import_('/common/error/500')
      }
    ]
  },

  // signin router
  {
    path: '/signin',
    name: 'signin',
    component: import_('/signin')
  },

  {
    path: '/dev',
    name: 'dev',
    component: import_('/common/debug/dev')
  },
]

const mainRoute = {
  path: '/',
  redirect: '/dashboard',
  component: Layout,
  children: []
}

const extraRoute = [{
  path: '*',
  redirect: { name: 'error.404' }
}]

const defaultRoute = [{
    path: '/system',
    component: Layout,
    name: 'system',
    meta: { title: '系统设置', icon: 'i-icon icon-setting' },
    children: [{
        path: 'menu',
        name: 'system.menu',
        meta: { title: '菜单设置' },
        component: import_('/system/menu'),
      },
      {
        path: 'module',
        name: 'system.module',
        meta: { title: '模块设置' },
        component: import_('/system/module'),
      },
      {
        path: 'role',
        name: 'system.role',
        meta: { title: '角色管理' },
        component: import_('/system/role'),
      },
      {
        path: 'user',
        name: 'system.user',
        meta: { title: '用户管理' },
        component: import_('/system/user')
      },
      {
        path: 'user',
        name: 'system.account.sys',
        meta: { title: '系统用户管理' },
        component: import_('/system/account/sys')
      },
      {
        path: 'account',
        name: 'system.account.partner',
        meta: { title: '合作伙伴管理' },
        component: import_('/system/account/partner')
      },
      {
        path: 'account',
        name: 'system.account.company',
        meta: { title: '平台用户' },
        component: import_('/system/account/company')
      },
      {
        path: 'org',
        name: 'system.account.org',
        meta: { title: '监管用户' },
        component: import_('/system/account/org')
      }
    ]
  },
  {
    path:'/license',
    component: Layout,
    name: 'license',
    meta: { title: '证照系统', icon: 'i-icon icon-credentials' },
    children: [
      {
        path: 'manage',
        name: 'license.manage',
        meta: { title: '证照管理' },
        component: import_('/license/manage')
      },
      {
        path: 'policy',
        name: 'license.policy',
        meta: { title: '证照策略' },
        component: import_('/license/policy')
      },
      {
        path: 'exam',
        name: 'license.exam',
        meta: { title: '证照考试' },
        component: import_('/license/exam')
      },
      {
        path: 'violation',
        name: 'license.violation',
        meta: { title: '违章记录管理' },
        component: import_('/license/violation')
      },
      {
        path: 'exception',
        name: 'license.exception',
        meta: { title: '异常登记' },
        component: import_('/license/exception')
      },
    ]
  },
  {
    path:'/finance',
    component: Layout,
    name: 'finance',
    meta: { title: '金融管理', icon: 'i-icon icon-financial' },
    children: [
      {
        path: 'company',
        name: 'finance.company',
        meta: { title: '金融公司' },
        component: import_('/partner/company')
      },
      {
        path: 'company',
        name: 'finance.insurance',
        meta: { title: '保险产品' },
        component: import_('/partner/insurance')
      },
      {
        path: 'company',
        name: 'finance.installment',
        meta: { title: '金融方案' },
        component: import_('/partner/installment')
      },
      {
        path: 'company',
        name: 'finance.insuranceReminder',
        meta: { title: '保险到期记录' },
        component: import_('/partner/insurance-reminder')
      }
    ]
  },
  {
    path: '/setting',
    component: Layout,
    name: 'setting',
    meta: { title: '基础设置', icon: 'i-icon icon-setting1' },
    children: [{
        path: 'accountingRule',
        name: 'setting.accountingRule',
        meta: { title: '计费规则' },
        component: import_('/setting/accountingRule')
      },
      {
        path: 'fence',
        name: 'setting.fence',
        meta: { title: '电子围栏' },
        component: import_('/setting/fence/list')
      },
      {
        path: 'brand',
        name: 'setting.brand',
        meta: { title: '品牌管理' },
        component: import_('/setting/brand')
      },
      {
        path: 'parts',
        name: 'setting.parts',
        meta: { title: '部件管理' },
        component: import_('/setting/parts')
      },
      {
        path: 'imp',
        name: 'setting.imp',
        meta: { title: '导入管理' },
        component: import_('/setting/imp')
      },
      {
        path: 'alarm',
        name: 'setting.alarm',
        meta: { title: '预警通知' },
        component: import_('/setting/alarm')
      },
      {

        path: 'notice',
        name: 'setting.notice',
        meta: { title: '公告管理' },
        component: import_('/setting/notice')
      },
      {
        path: 'infoRelease',
        name: 'setting.infoRelease',
        meta: { title: '信息发布' },
        component: import_('/setting/infoRelease')
      },
      {
        path: 'operational-warning',
        name: 'setting.operationalWarning',
        meta: { title: '经营预警配置' },
        component: import_('/setting/operational-warning')
      },
    ]
  },
  {
    path: '/organization',
    component: Layout,
    name: 'organization',
    meta: { title: '监管机构模块', icon: 'i-icon icon-company' },
    children: [
      {
        path: 'organization',
        name: 'organization.list',
        meta: { title: '机构信息' },
        component: import_('/organization'),
      },
      {
        path: 'policeman',
        name: 'organization.policeman',
        meta: { title: '警员管理' },
        component: import_('/organization/policeman'),
      },
    ]
  },
  {
    path: '/company',
    component: Layout,
    name: 'company',
    meta: { title: '企业模块', icon: 'i-icon icon-company' },
    children: [{
        path: 'group',
        name: 'company.group',
        meta: { title: '企业分组' },
        component: import_('/company/group/list'),
      },
      {
        path: 'info',
        name: 'company.info',
        meta: { title: '企业信息' },
        component: import_('/company/info/list'),
      },
      {
        path: 'map',
        name: 'company.map',
        meta: { title: '企业信息' },
        component: import_('/company/info/map'),
      },
      {
        path: 'map/new',
        name: 'company.map.new',
        component: import_('/company/info/map')
      },
      {
        path: 'branch',
        name: 'company.branch',
        meta: { title: '企业网点' },
        component: import_('/company/info/branch'),
      },
      {
        path: 'brand',
        name: 'company.brand',
        meta: { title: '企业品牌' },
        component: import_('/company/brand/list'),
      },
      {
        path: 'user',
        name: 'company.user',
        meta: { title: '企业用户管理' },
        component: import_('/company/user/list'),
      },
      {
        path: 'post',
        name: 'company.post',
        meta: { title: '企业岗位管理' },
        component: import_('/company/post/list'),
      },
      {
        path: 'shift',
        name: 'company.shift',
        meta: { title: '企业班次管理' },
        component: import_('/company/shift/list'),
      },
      {
        path: 'schedule',
        name: 'company.schedule',
        meta: { title: '排班管理' },
        component: import_('/company/schedule/index'),
      },
      {
        path: 'inspection-type',
        name: 'company.inspectionType',
        meta: { title: '巡检类型' },
        component: import_('/company/inspection/type/index'),
      },
      {
        path: 'inspection',
        name: 'company.inspection',
        meta: { title: '巡检信息' },
        component: import_('/company/inspection/index'),
      },
      {
        path: 'device',
        name: 'company.device',
        meta: { title: '企业设备' },
        component: import_('/company/device/index'),
      },
    ]
  },
  {
    path: '/courier',
    component: Layout,
    name: 'courier',
    meta: { title: '快递员模块', icon: 'i-icon icon-kuaidiyuan' },
    children: [
      {
        path: '',
        name: 'courier.list',
        meta: { title: '快递员模块' },
        component: import_('/courier/list'),
      }
    ]
  },
  {
    path: '/billing',
    component: Layout,
    name: 'billing',
    meta: { title: 'Billing', icon: 'i-icon icon-financial' },
    children: [{
      path: '',
      name: 'billing.invoice.list',
      meta: { title: 'Invoice' },
      component: import_('/billing/invoice'),
    }]
  },
  {
    path: '/car',
    component: Layout,
    name: 'car',
    meta: { title: '车辆管理模块', icon: 'i-icon icon-car' },
    children: [{
        path: 'info',
        name: 'car.info',
        meta: { title: '车辆信息' },
        component: import_('/car/info/list'),
      },
      {
        path: 'info',
        name: 'car.empty',
        meta: { title: '车辆空列表' },
        component: import_('/car/info/empty'),
      },
      {
        path: 'stock',
        name: 'car.stock',
        meta: { title: '车辆库存' },
        component: import_('/car/stock/list'),
      },
      {
        path: 'cate',
        name: 'car.cate',
        meta: { title: '车辆类型' },
        component: import_('/car/cate'),
      },
      {
        path: 'section',
        name: 'car.section',
        meta: { title: '车辆号段' },
        component: import_('/car/section/list'),
      },
      {
        path: 'log',
        name: 'car.log',
        meta: { title: '车辆使用记录' },
        component: import_('/car/log'),
      },
      {
        path: 'map',
        name: 'car.map',
        meta: { title: '车辆实时状态' },
        component: import_('/car/info/map'),
      },
      {
        path: 'map/new',
        meta: { title: '车辆实时状态' },
        name: 'car.map.new',
        component: import_('/car/info/map')
      },
      {
        path: 'updateRate',
        name: 'car.updateRate',
        meta: { title: '车辆更新率' },
        component: import_('/car/updateRate/list'),
      },
    ]
  },
  {
    path: '/device',
    component: Layout,
    name: 'device',
    meta: { title: '设备管理', icon: 'i-icon icon-routerwireless' },
    children: [{
        path: 'info',
        name: 'device.info',
        meta: { title: '设备信息' },
        component: import_('/device/info/list'),
      },
      {
        path: 'rfid',
        name: 'device.rfid',
        meta: { title: 'RFID设备信息' },
        component: import_('/device/rfid'),
      },
      {
        path: 'location',
        name: 'device.location',
        meta: { title: '定位信息' },
        component: import_('/device/location/index'),
      },
      {
        path: 'command',
        name: 'device.command',
        meta: { title: '下发命令' },
        component: import_('/device/command/index'),
      },
      {
        path: 'command/fast',
        name: 'device.fastCommand',
        meta: { title: '快速下发' },
        component: import_('/device/command/lite'),
      },
      {
        path: 'command/log',
        name: 'device.cmdlog',
        meta: { title: '下发记录' },
        component: import_('/device/command/log'),
      },
      {
        path: 'device/qrcode',
        name: 'device.qrcode',
        meta: { title: '二维码生成' },
        component: import_('/device/qrcode'),
      },
      {
        path: 'device/sim',
        name: 'device.sim',
        meta: { title: 'SIM卡信息' },
        component: import_('/device/sim'),
      }
    ]
  },
  {
    path: '/om',
    component: Layout,
    name: 'om',
    meta: { title: '运维管理', icon: 'i-icon icon-om' },
    children: [{
        path: 'command',
        name: 'om.command',
        meta: { title: '下发命令' },
        component: import_('/om/command'),
      },
      {
        path: 'qrcode',
        name: 'om.qrcode',
        meta: { title: '二维码生成' },
        component: import_('/om/qrcode'),
      }
    ]
  },
  {
    path: '/app',
    component: Layout,
    name: 'app',
    meta: { title: 'APP管理', icon: 'i-icon icon-application' },
    children: [{
      path: 'version',
      name: 'app.version',
      meta: { title: '版本管理' },
      component: import_('/app/version'),
    }]
  },
  {
    path:'/battery',
    component: Layout,
    name:'battery',
    meta: { title: 'BMS管理', icon: 'i-icon icon-battery3' },
    children: [{
      path: 'alarm',
      name: 'battery.alarm',
      meta: { title: '告警管理' },
      component: import_('/battery/alarm'),
    }]
  },
  {
    path: '/stats',
    component: Layout,
    name: 'stats',
    meta: { title: '数据统计', icon: 'i-icon icon-statistics' },
    children: [{
        path: 'car',
        name: 'stats.car',
        meta: { title: '车辆里程时长' },
        component: import_('/stats/car'),
      },
      {
        path: 'courier',
        name: 'stats.courier',
        meta: { title: '快递员里程' },
        component: import_('/stats/courier'),
      },
      {
        path: 'courier-violation',
        name: 'stats.courierViolation',
        meta: { title: '快递员违法' },
        component: import_('/stats/courier-violation'),
      },
      {
        path: 'company-violation',
        name: 'stats.companyViolation',
        meta: { title: '企业违法' },
        component: import_('/stats/company-violation'),
      },
      {
        path: 'violation',
        name: 'stats.violation',
        meta: { title: '违法热力图' },
        component: import_('/stats/violation'),
      },
      {
        path: 'fence-alarm',
        name: 'stats.fenceAlarm',
        meta: { title: '围栏预警' },
        component: import_('/stats/fence'),
      },
      {
        path: 'overdue-car',
        name: 'stats.overdue',
        meta: { title: '欠费逾期统计' },
        component: import_('/stats/overdue'),
      },
      {
        path: 'company-warning-record',
        name: 'company.warning',
        meta: { title: '企业经营异常记录' },
        component: import_('/company/warning'),
      },
      {
        path: 'company-warning',
        name: 'stats.companyWarning',
        meta: { title: '企业经营异常统计' },
        component: import_('/stats/company-warning'),
      },
      {
        path: 'car-warning',
        name: 'stats.carWarning',
        meta: { title: '车辆异常统计' },
        component: import_('/stats/car-warning'),
      },
      {
        path: 'brand',
        name: 'stats.brand',
        meta: { title: '品牌经营统计' },
        component: import_('/stats/brand'),
      },
      {
        path: 'brand-insurance',
        name: 'stats.brandInsurance',
        meta: { title: '品牌保险统计' },
        component: import_('/stats/brand-insurance'),
      },
      {
        path: 'speed-warning',
        name: 'stats.speedWarning',
        meta: { title: '速度预警统计' },
        component: import_('/stats/speed-warning'),
      },
      {
        path: 'brand-train',
        name: 'stats.brandTrain',
        meta: { title: '品牌培训统计' },
        component: import_('/stats/brand-train'),
      },
      {
        path: 'company-train',
        name: 'stats.companyTrain',
        meta: { title: '企业培训统计' },
        component: import_('/stats/company-train'),
      },
    ]
  },
  {
    path: '/support',
    component: Layout,
    name: 'support',
    meta: { title: '支持中心', icon: 'i-icon icon-support' },
    children: [{
      path: 'ticket',
      name: 'support.ticket',
      meta: { title: '工单列表' },
      component: import_('/support/ticket'),
    }]
  },
  {
    path: '/ass',
    component: Layout,
    name: 'ass',
    meta: { title: '维修管理', icon: 'i-icon icon-support' },
    children: [{
        path: 'branch',
        name: 'ass.branch',
        meta: { title: '站点信息' },
        component: import_('/ass/branch'),
      },
      {
        path: 'user',
        name: 'ass.user',
        meta: { title: '站点用户' },
        component: import_('/ass/user'),
      },
      {
        path: 'user',
        name: 'ass.employee',
        meta: { title: '维修师' },
        component: import_('/ass/employee'),
      },
      {
        path: 'feetpl',
        name: 'ass.feetpl',
        meta: { title: '上门费模板' },
        component: import_('/ass/feetpl'),
      },
      {
        path: 'ticket',
        name: 'ass.ticket',
        meta: { title: '工单管理' },
        component: import_('/ass/ticket'),
      },
      {
        path: 'partscate',
        name: 'ass.partscate',
        meta: { title: '配件分类' },
        component: import_('/ass/parts/cate'),
      },
      {
        path: 'parts',
        name: 'ass.parts',
        meta: { title: '配件商品' },
        component: import_('/ass/parts/goods'),
      },
      {
        path: 'supplier',
        name: 'ass.supplier',
        meta: { title: '供应商' },
        component: import_('/ass/supplier'),
      },
      {
        path: 'orderStats',
        name: 'ass.orderStats',
        meta: { title: '工单统计' },
        component: import_('/ass/orderStats'),
      },
    ]
  },
  {
    path: '/std',
    component: Layout,
    name: 'std',
    meta: { title: '标准化管理', icon: 'i-icon icon-iso' },
    children: [{
        path: 'car',
        name: 'std.car',
        meta: { title: '车辆标准化' },
        component: import_('/std/car'),
      },
      {
        path: 'installation',
        name: 'std.installation',
        meta: { title: '安装单' },
        component: import_('/std/installation'),
      },
      {
        path: 'application',
        name: 'std.application',
        meta: { title: '申请单' },
        component: import_('/std/application'),
      },
      {
        path: 'progress',
        name: 'std.progress',
        meta: { title: '标准化进度' },
        component: import_('/std/progress'),
      },
      {
        path: 'carPlate',
        name: 'std.license',
        meta: { title: '车牌管理' },
        component: import_('/std/carPlate')
      },
      {
        path: 'installProgress',
        name: 'std.installProgress',
        meta: { title: '安装进度' },
        component: import_('/std/installProgress'),
      },
    ]
  },
  {
    path: '/logistics',
    component: Layout,
    name: 'logistics',
    meta: { title: '一键派送', icon: 'i-icon icon-kuaidi' },
    children: [{
        path: 'order',
        name: 'logistics.order',
        meta: { title: '订单管理' },
        component: import_('/logistics/order'),
      },
      {
        path: 'route',
        name: 'logistics.route',
        meta: { title: '派送路径' },
        component: import_('/logistics/route'),
      },
    ]
  },
  {
    path: '/exam',
    component: Layout,
    name: 'exam',
    meta: { title: '题库管理', icon: 'i-icon icon-kuaidi' },
    children: [{
        path: 'exam',
        name: 'exam.qa',
        meta: { title: '题库列表' },
        component: import_('/exam/question'),
      },
      {
        path: 'exam',
        name: 'exam.tpl',
        meta: { title: '模板管理' },
        component: import_('/exam/template'),
      },
      {
        path: 'exam',
        name: 'exam.video',
        meta: { title: '视频资料' },
        component: import_('/exam/video'),
      },
    ]
  },
  {
    path: '/mall',
    component: Layout,
    name: 'mall',
    meta: { title: '商城管理', icon: 'i-icon icon-kuaidi' },
    children: [
      {
        path: 'courier',
        name: 'mall.courier',
        meta: { title: '快递员模块' },
        component: import_('/courier/list'),
      },
      {
        path: 'deposit',
        name: 'mall.deposit',
        meta: { title: '押金方案' },
        component: import_('/mall/deposit'),
      },
      {
        path: 'product',
        name: 'mall.product',
        meta: { title: '商品管理' },
        component: import_('/mall/product'),
      },
      {
        path: 'order',
        name: 'mall.order',
        meta: { title: '订单管理' },
        component: import_('/mall/order'),
      },
      // {
      //   path: 'exam',
      //   name: 'mall.video',
      //   meta: { title: '视频资料' },
      //   component: import_('/exam/video'),
      // },
    ]
  },
]
// 白名单 任意状态可见
export const whiteList = [
  'signin',
  'resetPwd',
  'error',
  'dev',
  'debug',
]

const flatten = function(r, p = '', obj = {}) {
  for(let i of r) {
    if (i.name) {
      obj[i.name] = {
        name: i.name,
        title: i.meta ? i.meta.title : i.name,
        icon: i.meta ? i.meta.icon : null,
        path: (p + i.path).replace(/\/\//g, '/'),
        component: i.component
      }
    }

    if (i.children) {
      flatten(i.children, i.path, obj)
    }
  }

  return obj
}

// code定位component, 菜单id做name,同时建立 菜单id与name 映射关系
const linkComponent = (data = []) => data.map(i => {
  let hit = componentMap[i.code] || {}
  //外链
  if(!hit.name && (i.code.startsWith('/') || i.path.startsWith('http')) ){
    exlinksRoute[i.id] = i.path
  }else {
    flatRoute[hit.name] = i.id
  }

  return {
    path: i.path,
    name: i.id,
    meta: { title: i.title || hit.title, icon: hit.icon || '' },
    component: hit.component,
    children: Array.isArray(i.children) ? linkComponent(i.children) : []
  }
})

const linkStaticRoute = (data = [] , ret = {}) => {
  for(let i of data){
    if (i.name) ret[i.name] = i.name
    if (i.children) {
      linkStaticRoute(i.children,ret)
    }
  }
  return ret
}

// 菜单生成动态路由
const createDynamicRoute = (data) => {
  flatRoute = linkStaticRoute(staticRoute)
  return linkComponent(data).concat(extraRoute, staticRoute)
}

//根据code获取最相似的路由
const getNearestRoute = (code) => flatRoute[code]

const getExLink = (name) => {
  return exlinksRoute[name]
}

const isStaticRoute = (name) => {
  return !!flatStaticRoute[name]
}
//name->component 映射表
const componentMap = flatten(defaultRoute)

const flatStaticRoute = linkStaticRoute(staticRoute)
//当前权限下 code -> menu_id 映射表,如果多个菜单共用code,会有问题。
let flatRoute = {}

//外链路由
const exlinksRoute = {}

export { staticRoute, isStaticRoute, defaultRoute, componentMap, createDynamicRoute, getNearestRoute , getExLink }